import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3f066b3f&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=3f066b3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f066b3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f066b3f')) {
      api.createRecord('3f066b3f', component.options)
    } else {
      api.reload('3f066b3f', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=3f066b3f&scoped=true&", function () {
      api.rerender('3f066b3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/onePageAdv3/Index.vue"
export default component.exports